// dependencies
import React from "react";

import SelectInput, { Result } from "../../../../../components/Inputs/SelectInput";

import { FieldCategory } from "../../../schemas/report";

// config
import Config from "../Config";

interface BaseProps {
	onChange: (value: any) => void;
	fieldCategory: FieldCategory;
	value: unknown;
}

const StatusSelector = (props: BaseProps) => {
	const { onChange, value, fieldCategory } = props;

	const statusesForCategory = Config.categoryOptions.find((cat) => cat.value === fieldCategory)?.statuses ?? [];

	return (
		<SelectInput
			setFirstResult={false}
			results={statusesForCategory}
			name={fieldCategory}
			onChange={onChange}
			value={value as Result}
		/>
	);
};

export default StatusSelector;
